export default {
  title: 'Leads',
  description: 'Trabalhe as empresas disponíveis para o tenant, acompanhe o lifecycle comercial e mantenha uma única identidade por vínculo.',
  form: {
    title: 'Cadastro de Lead',
    description: 'Escolha uma empresa disponível para o tenant e acompanhe o estado do trabalho comercial.',
  },
  groups: {
    identification: 'Identificação',
  },
  fields: {
    candidate: 'Empresa',
    state: 'Estado',
    createdAt: 'Criado em',
  },
  states: {
    new: 'Novo',
    working: 'Em trabalho',
    qualified: 'Qualificado',
    disqualified: 'Desqualificado',
    closed: 'Encerrado',
  },
};
